import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useResolve, ScanError } from "./Scan";
import { useLang } from "../lib/i18n";

export default function LabelLink() {
  const { token } = useParams();
  const { resolve, err } = useResolve();
  const { t } = useLang();
  useEffect(() => { resolve(token); }, [token, resolve]);
  return (
    <div className="max-w-md mx-auto p-6 space-y-4" data-testid="label-link-page">
      {err ? <ScanError err={err} /> : <p className="text-slate-600">{t("loading")}</p>}
      <Link to="/" className="btn-secondary">{t("back")}</Link>
    </div>
  );
}
